var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "alert alert-dismissible fade show m-alert m-alert--air",
      class: _vm.alertType,
      attrs: { role: "alert" }
    },
    [
      _c("button", {
        staticClass: "close",
        attrs: {
          id: "btn-close-alert",
          type: "button",
          "data-dismiss": "alert",
          "aria-label": "Close"
        }
      }),
      _vm._v("\n  " + _vm._s(_vm.body) + "\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de8484a8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de8484a8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/alert/Alert.vue
// module id = 298
// module chunks = 0 1 139 145 146 178